import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { SearchToneRequest } from '../api/search/searchtone/searchtonerequest';
import { SearchToneResponse, SearchToneResponseDtoImpl } from '../api/search/searchtone/searchtoneresponse';
import { SearchToneBuilder } from '../dto/searchtone/searchtonebuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SearchToneDtoImpl } from '../dto/searchtone/searchtonedto';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';

export class SearchToneAPIProcessorImpl extends APIProcessorImpl<SearchToneRequest, SearchToneResponse>
{
    private LOGGER: Logger = LogManager.getLogger(SearchToneAPIProcessorImpl.name);
    execute(request: SearchToneRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        this.LOGGER.log("onSuccess() invoked");
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

               let response = new SearchToneResponseDtoImpl(APIFeatures.SEARCH_TONE, "Search Tone Success");

               let searchToneDto = new SearchToneDtoImpl();
               searchToneDto.setListOfTones(new SearchToneBuilder(responseMapper.getResponseMap(), this.getContext()).buildAll());
               response.setSearchToneDto(searchToneDto);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new SearchToneResponseDtoImpl(APIFeatures.SEARCH_TONE, "No Search tone Data Available"));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new SearchToneResponseDtoImpl(APIFeatures.SEARCH_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new SearchToneResponseDtoImpl(APIFeatures.SEARCH_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
 
            this.getAPIFailure(new SearchToneResponseDtoImpl(APIFeatures.SEARCH_TONE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/searchtoneapiprocessor.tsx